import { createFileRoute } from '@tanstack/react-router';
import { FileText } from 'lucide-react';
import { SelectionPlaceholder } from '@/components/molecules';

export const Route = createFileRoute('/_dashboard/dashboard/proposals/')({
  component: () => (
    <SelectionPlaceholder
      icon={FileText}
      title="Select a proposal"
      iconClassName="h-8 w-8 opacity-30"
      className="flex h-full flex-col items-center justify-center gap-2 text-muted-foreground"
    />
  ),
});
